module.exports = __webpack_public_path__ + "img/15.59b69297.jpg";